module.exports = __webpack_public_path__ + "img/scount-app.a7166a41.png";